import React from 'react';
import PropTypes from 'prop-types';
import JobCard from '../job-card/View';

function JobCards({ jobsLists, loader }) {
	return (
		<div className='c-job-cards'>
			{jobsLists.map((job) => (
				<JobCard
					logoUrl={job.logo_url}
					jobTitle={job.job_title}
					jobURL={job.job_url}
					companyName={job.company_name}
					pinLists={job.pin_lists}
					postedDate={job.modified_date}
					isExternalLink={job.is_external_link}
					key={job.id}
					loader={loader}
					isEasyApply={job.is_easy_apply}
				/>
			))}
		</div>
	);
}

JobCards.propTypes = {
	jobsLists: PropTypes.arrayOf(PropTypes.object),
	loader: PropTypes.bool,
};

// JobCards.defaultProps = {
// 	jobsLists: [],
// 	loader: false,
// };

export default JobCards;
